import React from 'react';

const SupplierList = ({
  suppliers,
  filters,
  onFilterChange,
  onEdit,
  onDelete,
  readOnly = false
}) => (
  <table>
    <thead>
      <tr>
        <th>
          Name
          <br />
          <input
            type="text"
            value={filters.supplier_name}
            onChange={e => onFilterChange('supplier_name', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Address
          <br />
          <input
            type="text"
            value={filters.supplier_address}
            onChange={e => onFilterChange('supplier_address', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Contact Info
          <br />
          <input
            type="text"
            value={filters.supplier_contact_info}
            onChange={e => onFilterChange('supplier_contact_info', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>{readOnly ? 'View' : 'Actions'}</th>
      </tr>
    </thead>
    <tbody>
      {suppliers.map(supplier => (
        <tr key={supplier.supplier_id}>
          <td>{supplier.supplier_name}</td>
          <td>{supplier.supplier_address}</td>
          <td>{supplier.supplier_contact_info}</td>
          <td>
            {!readOnly && onEdit && (
              <button onClick={() => onEdit(supplier)}>Edit</button>
            )}
            {!readOnly && onDelete && (
              <button 
                onClick={() => onDelete(supplier.supplier_id)}
                style={{ 
                  marginLeft: onEdit ? 8 : 0, 
                  backgroundColor: '#dc3545', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '4px', 
                  padding: '0.25rem 0.5rem', 
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
              >
                Delete
              </button>
            )}
            {readOnly && (
              <span style={{ color: '#666', fontStyle: 'italic' }}>View Only</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default SupplierList;